import React from 'react';
import s from './VisuallyHidden.scss';
/*
  Sometimes we need to include elements for accessibility reasons
  but design doesn't like those elements. So we use this component to
  make the element accessible to a screen reader, but hidden visually.
*/
var VisuallyHidden = function (_a) {
    var children = _a.children;
    return React.createElement("span", { className: s['root'] }, children);
};
VisuallyHidden.displayName = 'VisuallyHidden';
export default VisuallyHidden;
//# sourceMappingURL=VisuallyHidden.js.map